export default __webpack_public_path__ + "static/Locations-hero-ee25a0702317f19260d8711f3e541e0d.png";